// Web: use the native Web Crypto API
const webCrypto = globalThis.crypto;
export default webCrypto;
